const $ = jQuery;

export default function (ctx = document) {
    const $popup = $(ctx).find('.js-recommendation-popup');

    if (!$popup.length) return;

    const closePopup = () => {
        $popup.removeClass('is-visible').addClass('is-hidden');
    };

    // Show popup after 3 seconds delay with animation
    setTimeout(() => {
        $popup.removeClass('is-hidden').addClass('is-visible');
    }, 3000);

    $(ctx).on('click', '.js-recommendation-popup-close', function (e) {
        e.preventDefault();
        closePopup();
    });

    $(document).on('keydown.recommendationPopup', function (e) {
        if (e.key === 'Escape' && $popup.length && $popup.hasClass('is-visible')) {
            closePopup();
        }
    });
}
